import axios from "../api";
export const markSbcSolved = async (sbcId, setId, solved) => {
    await axios.post("/mark-sbc-solved", { sbcId, setId, solved });
};
//# sourceMappingURL=markSbcSolved.js.map